import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info-dialog-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      role: 'button',
      "svg-inline": '',
      class: _normalizeClass('info-bubble'),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"])),
      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onhover && _ctx.open())),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onhover && _ctx.close())),
      tabindex: '0',
      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["stop"]), ["enter"])),
      focusable: 'false'
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("path", { d: "M15.07 11.25l-.9.92C13.45 12.89 13 13.5 13 15h-2v-.5c0-1.11.45-2.11 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41a2 2 0 00-2-2 2 2 0 00-2 2H8a4 4 0 014-4 4 4 0 014 4 3.2 3.2 0 01-.93 2.25M13 19h-2v-2h2M12 2A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10c0-5.53-4.5-10-10-10z" }, null, -1)
    ]))], 32)),
    _createVNode(_Transition, {
      name: "dialog",
      onEnter: _ctx.enter
    }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["info-dialog", _ctx.sideClass]),
              ref: "dialogBox",
              tabindex: "-1",
              style: _normalizeStyle(_ctx.styleDialog)
            }, [
              _createElementVNode("div", {
                class: "info-dialog-corner",
                style: _normalizeStyle(_ctx.styleCorner)
              }, null, 4),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onEnter"])
  ]))
}